const FormatSchoolYearIdentifier = (schoolYearIdentifier) => {
  const year = parseInt(schoolYearIdentifier, 10);
  return Number.isNaN(year) ? "" : `${year - 1}-${year}`;
};

export { FormatSchoolYearIdentifier };
